import { create, show } from "@ebay/nice-modal-react";
import React, { useCallback, useState } from "react";

import InputText from "components/input/InputText";
import LinkButton from "ds/components/Button/LinkButton";
import ModalContent from "ds/components/Modal/Content";
import ModalHeader from "ds/components/Modal/Header";
import ModalSimple from "ds/components/ModalSimple";
import Typography from "ds/components/Typography";
import SpaceliftLogo from "ds/components/SpaceliftLogo/Logo";
import { AllowedRegion, getRegionPartOfDomain } from "utils/region";

import styles from "./styles.module.css";
import { extractAppURL } from "./utils";

type MainNavigationLoginListModalProps = {
  logins: { accountName: string; region: AllowedRegion }[];
};

const MainNavigationLoginListModal = create(function MainNavigationLoginListModal({
  logins,
}: MainNavigationLoginListModalProps) {
  const [login, setLogin] = useState("");

  const appURL = extractAppURL(window.location.hostname);

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => setLogin(e.target.value),
    [setLogin]
  );

  return (
    <ModalSimple>
      <ModalHeader title="Change account" />
      <ModalContent gap="medium">
        <Typography tag="p" variant="p-body2">
          Use one of the recent accounts
        </Typography>
        <ul className={styles.modalList}>
          {logins.map(({ accountName, region }) => {
            const regionPartOfDomain = getRegionPartOfDomain(region);
            const login = regionPartOfDomain ? `${accountName}.${regionPartOfDomain}` : accountName;

            return (
              <li key={`login-${login}`}>
                <a className={styles.modalListLink} href={`https://${login}.${appURL}`}>
                  <SpaceliftLogo className={styles.modalListLogo} size="medium" />

                  {`${login}.${appURL}`}
                </a>
              </li>
            );
          })}
        </ul>
        <Typography tag="p" variant="p-body2">
          or enter GitHub user / organization name
        </Typography>
        <InputText
          className={styles.modalInput}
          value={login}
          onChange={handleInputChange}
          bordered
        />

        <LinkButton
          variant="primary"
          href={`https://${login}.${appURL}`}
          disabled={!login}
          fullWidth
        >
          Switch account
        </LinkButton>
      </ModalContent>
    </ModalSimple>
  );
});

export const showLoginListModal = (props: MainNavigationLoginListModalProps) =>
  show(MainNavigationLoginListModal, props);
